// Bella Vita frontend — runtime configuration.
//
// The adapter selector is the ONLY integration seam between the UI and a
// backend. Production/default runtime is the controlled Odoo API. Mock data is
// development scaffolding and must be selected explicitly with
// VITE_BV_ADAPTER=mock — production must never silently fall back to fixtures.

const env = import.meta.env ?? {};
const requestedAdapter = env.VITE_BV_ADAPTER || 'odoo';
const adapter = requestedAdapter === 'mock' ? 'mock' : 'odoo';

export const CONFIG = {
  // 'mock' | 'odoo'
  adapter,

  // Base URL of the future Bella Vita API (controlled endpoints only — never
  // unrestricted Odoo JSON-RPC / web endpoints). Unused by the mock adapter.
  apiBaseUrl: env.VITE_BV_API_BASE || '',

  // Simulated network latency for the mock adapter (ms) so loading / error /
  // retry states are real during development.
  mockLatencyMs: Number(env.VITE_BV_MOCK_LATENCY ?? 450),

  // Probability (0..1) the mock adapter throws, to exercise error/retry UI.
  // 0 by default; raise locally to test failure states.
  mockErrorRate: Number(env.VITE_BV_MOCK_ERROR_RATE ?? 0),

  // Persisted booking-state schema version. Bump on any breaking shape change
  // to src/store/booking.js so stale sessions fail safe instead of corrupting.
  bookingStateVersion: 2,

  defaultLang: 'ar',
  supportedLangs: ['ar', 'en'],
};
